import React from 'react';

type Props = {};

export default function Page1({}: Props) {
	return (
		<>
			<h1 className="text-5xl font-medium border-b-2 border-b-customBlue w-fit pb-2">Cześć słoneczko :)</h1>
			<p>
				Przyznam szczerze, że niezmiernie się cieszę, że mogłem dla Ciebie to małe zaproszonko przygotować. Wprawdzie chciałem zaimplementować
				tutaj własny carousel-component (taka lista przewijalna w kółko), ale z tego co pamiętam nie jest to najprostsze do napisania, a czas tu
				mnie już mocno goni bo właśnie powiedziałaś, że uciekasz lulu...
			</p>

			<p className="">
				Niemniej sorryy XDD, już kończe z tym programistycznym gadaniem. Chciałem Ci tu na wstępie też ogromnie podziękować za wyrozumiałość i w
				ogóle możliwość doprowadzenia do momentu, w którym tworzę te małe zaproszonko. Naprawdę niesamowicie cieszę się, że mam Cię Jula znów w
				życiu bo z nikim nigdy się tak nie dogadywałem jak z Tobą. Tyle ile przez ten miesiąc śmiechu i radości z Tobą miałem to nie idzie
				zliczyć. Niesamowicie za Ciebie jestem wdzięczny i dlatego też nie mam żadnych wątpliwości co do tego, czy chciałbym dalej iść z Tobą
				przez życie, dlategoooo też chciałem zapytać... (kliknij dalej :P)
			</p>

			<i className="text-customBlue">PS: Nie wiem, czy dziś już to mówiłem, ale prześlicznie wyglądasz</i>
		</>
	);
}
